<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M18,10H2"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="2"
    />
    <path
      d="M10,2V18"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="2"
    />
  </svg>
</template>
